import React from "react";
import { theme } from "../../utils/theme";
import PropTypes from "prop-types";
import "./style.css";
import { getLocalizedString } from "../../utils";

export const MainButton = ({ component: Component, ...props }) => {
  let backgroundColor = "none";
  let border = "none";
  let color = theme.white;
  switch (props.type) {
    case "primary":
      backgroundColor = theme.primary;
      border = "none";
      color = theme.text;
      break;
    case "secondary":
      backgroundColor = theme.secondary;
      border = "none";
      color = theme.white;
      break;
    case "tertiary":
      backgroundColor = theme.tertiary;
      border = "none";
      color = theme.black;
      break;
    case "outline":
      backgroundColor = "transparent";
      border = "1px solid " + theme.alpha3;
      color = theme.text;
      break;
  }

  const mainStyle = {
    backgroundColor: props.disabled ? theme.lightGrey : backgroundColor,
    border,
    borderRadius: 3,
    height: props.height ? props.height : 40,
    fontSize: props.size ? props.size : 13,
    paddingLeft: 12,
    paddingRight: 12,
    width: "100%",
    color,
    textAlign: "center",
    outline: "none",
    display: "inline-block",
    appearance: "none",
    boxShadow: "none",
    cursor: "pointer",
    fontWeight: 500,
    textTransform: "uppercase",
  };

  return (
    <button
      className={props.type == "outline" ? "highlightOutline" : "none"}
      style={{ ...mainStyle, ...props.sx }}
      {...props}
    >
      <span>
        <span>
          <span>{props.label}</span>
        </span>
      </span>
    </button>
  );
};

MainButton.propTypes = {
  type: PropTypes.string.isRequired,
  label: PropTypes.any.isRequired,
  sx: PropTypes.object,
};
